import { render, staticRenderFns } from "./order-view-tabs-timeline.vue?vue&type=template&id=2e891688&"
import script from "./order-view-tabs-timeline.ts?vue&type=script&lang=ts&"
export * from "./order-view-tabs-timeline.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports